import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TabTitle from "./TabsTitle";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getLoginConfig,
  setIsLogin,
  setLoginUser,
} from "../../../redux/slices/loginconfigSlice";
import { setActivityIndicator } from "../../../redux/slices/appconfigSlice";
import { UpdateProfileService } from "../../../services/UpdateProfileService";
import { DeleteAccountService } from "../../../services/DeleteAccountService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useTranslationCustom from "../../../i18n/customHook/useTranslation";

const AccountTabContent = () => {
  const { T } = useTranslationCustom();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginconfig = useSelector(getLoginConfig);
  const [personalInfo, setPersonalInfo] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  useEffect(() => {
    if (loginconfig.isLogin) {
      setPersonalInfo({
        firstName: loginconfig.loginUser?.firstname,
        lastName: loginconfig.loginUser?.lastname,
        email: loginconfig.loginUser?.email,
      });
    }
  }, []);

  const onPersonalInfoChange = (e, type) => {
    e.preventDefault();
    setPersonalInfo({ ...personalInfo, [type]: e.target.value });
  };

  const handleOnUpdate = async (e) => {
    e.preventDefault();
    try {
      const params = {
        Guid: loginconfig.loginUser.guid,
        UpdateContent: "Name",
        NewFirstName: personalInfo.firstName,
        NewLastName: personalInfo.lastName,
        Locale: loginconfig?.locale?.code,
      };
      if (loginconfig.isLogin) {
        dispatch(setActivityIndicator(true));
        // console.log(params);

        await UpdateProfileService(params);
        dispatch(
          setLoginUser({
            ...loginconfig.loginUser,
            firstname: params.NewFirstName,
            lastname: params.NewLastName,
          })
        );
        dispatch(setActivityIndicator(false));
        toast.success(`${T("Toasts:Info_Updated")}`);
      }
    } catch {
      dispatch(setActivityIndicator(false));
    }
  };

  const handleLogout = () => {
    dispatch(setIsLogin(false));
    dispatch(setLoginUser({}));
    localStorage.removeItem("auth_token");
    toast.success(T("Toasts:Account_Deleted"));
    navigate("/me/settings");
  };

  const deleteAccount = () => {
    if (!loginconfig.isLogin) return;
    setShowDeleteConfirm(true);
  };

  const confirmDeleteAccount = () => {
    setShowDeleteConfirm(false);
    const params = {
      Guid: loginconfig?.loginUser?.guid,
    };
    dispatch(setActivityIndicator(true));
    DeleteAccountService(params)
      .then(() => {
        dispatch(setActivityIndicator(false));
        handleLogout();
      })
      .catch(() => {
        dispatch(setActivityIndicator(false));
      });
  };

  return (
    <>
      <div className="d-flex gap-3 align-items-center left-action-back-btn">
        <a className="black-back-btn" onClick={() => navigate(-1)}>{T("Buttons:Back")}</a>
        <TabTitle title={T("Buttons:Account")}></TabTitle>
      </div>
      <div className="tabs-inner-content">
        <div className="account-form-holder">
          <form>
            <div className="row">
              <div className="col-12">
                <h6 className="green-text fs-16 font-noto">
                  {T("Profile:Personal_Info")}
                </h6>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label-style" htmlFor="name">
                    {T("Profile:First_Name")}
                  </label>
                  <input
                    type="text"
                    name="name"
                    placeholder={T("Profile:Enter_Full_Name")}
                    className="input-style"
                    value={personalInfo?.firstName ?? ""}
                    onChange={(e) => onPersonalInfoChange(e, "firstName")}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label-style" htmlFor="real-name">
                    {T("Profile:Last_Name")}
                  </label>
                  <input
                    type="text"
                    name="real-name"
                    placeholder={T("Profile:Enter_Last_Name")}
                    className="input-style"
                    value={personalInfo?.lastName ?? ""}
                    onChange={(e) => onPersonalInfoChange(e, "lastName")}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label-style" htmlFor="email">
                    {T("Home:Home_Login_Modal_Email_Placeholder")}
                  </label>
                  <input
                    readOnly
                    type="email"
                    name="email"
                    placeholder={T("Home:Home_Signup_Modal_Email_Placeholder")}
                    className="input-style"
                    value={personalInfo?.email ?? ""}
                    onChange={(e) => onPersonalInfoChange(e, "email")}
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <a className="form-action" onClick={handleOnUpdate}>
                    {T("Buttons:Update_Profile")}
                  </a>
                </div>
              </div>
            </div>
          </form>
          <div className="row account-delete">
            <div className="col-md-12 text-center">
              <div className="mb-4">{T("Profile:Delete_Account")}?</div>
              <button className="delete-btn" onClick={deleteAccount}>
                {T("Buttons:Delete_Account_Button_Text")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showDeleteConfirm}
        onHide={() => setShowDeleteConfirm(false)}
        centered
        dialogClassName="delete-confirm-modal"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title>{T("Profile:Delete_Account")}: {T("Profile:Are_You_Sure")}</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <button
            className="confirm-btn confirm-btn-no"
            onClick={() => setShowDeleteConfirm(false)}
          >
            {T("Buttons:Button_No")}
          </button>
          <button
            className="confirm-btn confirm-btn-yes"
            onClick={confirmDeleteAccount}
          >
            {T("Buttons:Button_Yes")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AccountTabContent;
